const baseUrl = "http://192.168.230.252:8130";
const appBaseUrl = "http://192.168.230.252:8121";
const appQkzqBaseUrl = "http://192.168.230.252:8021";
module.exports = {
  baseApi: `${baseUrl}/api`, // 测试api请求地址
  appBaseUrl: `${appBaseUrl}/api`,
  appQkzqBaseUrl: `${appQkzqBaseUrl}/api`,
};
